module.exports = __webpack_public_path__ + "static/media/personalia.35904d61.png";